// src/components/TopDestinations.js

import React from 'react';
import destination1 from '../images/destination/destination1.jpg';
import destination2 from '../images/destination/destination2.jpg';
import destination15 from '../images/destination/2.avif';
import destination16 from '../images/destination/2.jpg';

const destinations = [
  {
    id: 1,
    image: destination2,
    title: 'Farm Stays',
    subtitle: 'Caspian Valley',
    tours: 18,
    fullWidth: true,
  },
  {
    id: 2,
    image: destination15,
    title: 'Mango Mahostav',
    subtitle: 'Russia',
    tours: 15,
  },
  {
    id: 3,
    image: destination16,
    title: 'Birds Watching',
    subtitle: 'America',
    tours: 32,
  },
  {
    id: 4,
    image: destination1,
    title: 'England',
    subtitle: 'London',
    tours: 15,
    largeRight: true,
  },
];

const TopDestinations = () => {
  return (
    <section className="trending pb-3 pt-0">
      <div className="container">
        <div className=" mb-6 w-5 mx-auto text-center">
          <h4 className="mb-1 theme1">About us</h4>
          <h2 className="mb-1">
            About our <span className="theme">Anand Krushi Paryatan Kendra</span>
          </h2>
          <p>
            Anand Krushi Paryatan Kendra is a platform built to showcase the beauty and richness of the Morachi Chincholi tourism destination.
          </p>
        </div>

        <div className="row align-items-center">
          <div className="col-lg-6">
            <div className="row">
              {destinations.slice(0, 3).map((dest, index) => (
                <div
                  key={dest.id}
                  className={`${
                    index === 0 ? 'col-lg-12' : 'col-lg-6 col-md-6 col-sm-6'
                  } mb-4`}
                >
                  <div className="trend-item1">
                    <div className="trend-image position-relative rounded">
                      <img src={dest.image} alt={dest.title} className="img-fluid" />
                      <div className="trend-content d-flex align-items-center justify-content-between position-absolute bottom-0 p-4 w-100 z-index">
                        <div className="trend-content-title">
                          <h5 className="mb-0">
                            <a href="/tour-grid" className="theme1">
                              {dest.title}
                            </a>  
                          </h5>
                          {/* <h3 className="mb-0 white">{dest.subtitle}</h3> */}
                        </div>
                        {/* <span className="white bg-theme p-1 px-2 rounded">{dest.tours} Tours</span> */}
                      </div>
                      <div className="color-overlay"></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="col-lg-6 mb-4">
            <div className="trend-item1">
            <p>

Welcome to Anand Krushi Paryatan Kendra, where you can relax in the calm countryside of Morachi Chincholi, Pune. Our place covers 40 acres of green land, full of tall trees and open spaces for you to enjoy.
When you walk around, you'll hear the leaves rustling and the sounds of nature. The air smells fresh and clean with flowers and earth. It's a peaceful place where you can take a break from busy life and be close to nature.
Our place has lots of room to explore, with big trees giving shade. You can take a slow walk or sit quietly. We also have comfy spots where you can relax with a book or just enjoy being outside. Besides the green areas, we have other things to make your visit nice. You can sit by the calm ponds and watch the sunlight on the water, or listen to the birds singing. Everywhere in Anand Krushi Paryatan Kendra is made to help you feel calm and relaxed. As you spend time here, you'll see the beauty of Morachi Chincholi all around. From colorful flowers to singing birds, nature's beauty is everywhere. Whether you're enjoying the sun or looking at the stars, you'll feel happy in our natural place.

At Anand Krushi Paryatan Kendra, we think being in nature is good for you. Whether you want to relax or spend time with family, we hope you'll like being here. Welcome, and we hope you have a happy and peaceful time with us.
            </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopDestinations;
